import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import styles from "./verse-comparison-slide.css";

import type { SlideState, VerseData } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-verse-comparison-slide")
export class VerseComparisonSlide extends LitElement {
  static styles = styles;

  @property()
  multiVerseData?: Array<VerseData>;

  @property()
  slideState?: SlideState;

  @property({ attribute: "title" })
  slideTitle?: string;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.multiVerseData) return null;

    return html`
      <bp-scrollable-slide
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">${unsafeHTML(this.slideTitle)}</div>
        <div slot="content" class="multi-verse-container">
          ${this.multiVerseData.map(
            (verseData) => html`
              <div data-id="${verseData.translation}">
                <div class="verse-header">${verseData.translation}</div>
                <div class="verse-content">${unsafeHTML(verseData.text)}</div>
              </div>
            `,
          )}
        </div>
      </bp-scrollable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-verse-comparison-slide": VerseComparisonSlide;
  }
}
